import { Button, Icon } from "@outschool/backpack";
import { faShare } from "@outschool/icons";
import React from "react";

type Props = React.ComponentPropsWithoutRef<typeof Button> & {
  url: string;
  text: string;
};

export const canShowNativeShare = () => !!navigator.share;

export function ShareButton({ url, text, ...props }: Props) {
  const handleShare = async () => {
    try {
      await navigator.share({
        text,
        url
      });
    } catch (error) {
      // Required to catch since it throws when the user cancels
      console.error(error);
    }
  };

  if (!canShowNativeShare()) {
    return null;
  }

  return (
    <Button
      variant="contained"
      startIcon={<Icon icon={faShare} />}
      onClick={handleShare}
      {...props}
    />
  );
}
